<template>
  <div :class="[alertClasses, 'p-4 mb-6 rounded-r-md border-l-4']" role="alert">
    <p v-if="title" class="font-bold mb-1">{{ title }}</p>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
  type: {
    type: String,
    default: 'info',
    validator: (value) => ['info', 'warning', 'danger', 'success'].includes(value)
  },
  title: {
    type: String,
    default: ''
  }
});

const alertClasses = computed(() => {
  switch (props.type) {
    case 'info':
      return 'bg-blue-50 dark:bg-blue-900 border-blue-500 text-blue-700 dark:text-blue-200';
    case 'warning':
      return 'bg-yellow-50 dark:bg-yellow-900 border-yellow-500 text-yellow-700 dark:text-yellow-200';
    case 'danger':
      return 'bg-red-50 dark:bg-red-900 border-red-500 text-red-700 dark:text-red-200';
    case 'success':
      return 'bg-green-50 dark:bg-green-900 border-green-500 text-green-700 dark:text-green-200';
    default:
      return '';
  }
});
</script>
